import { useState } from 'react';

const EMOJI_CATEGORIES = {
  recent: 'Recent',
  smileys: 'Gezichtjes',
  gestures: 'Gebaren',
  hearts: 'Harten',
  animals: 'Dieren',
  food: 'Eten',
  activities: 'Activiteiten',
  travel: 'Reizen',
  objects: 'Objecten',
  symbols: 'Symbolen',
  flags: 'Vlaggen',
} as const;

const EMOJI_SETS: Record<keyof typeof EMOJI_CATEGORIES, string[]> = {
  recent: [],
  smileys: [
    '\uD83D\uDE00', '\uD83D\uDE01', '\uD83D\uDE02', '\uD83D\uDE03', '\uD83D\uDE04',
    '\uD83D\uDE05', '\uD83D\uDE06', '\uD83D\uDE09', '\uD83D\uDE0A', '\uD83D\uDE0B',
    '\uD83D\uDE0C', '\uD83D\uDE0D', '\uD83D\uDE0E', '\uD83D\uDE0F', '\uD83D\uDE10',
    '\uD83D\uDE11', '\uD83D\uDE12', '\uD83D\uDE13', '\uD83D\uDE14', '\uD83D\uDE15',
    '\uD83D\uDE16', '\uD83D\uDE17', '\uD83D\uDE18', '\uD83D\uDE19', '\uD83D\uDE1A',
    '\uD83D\uDE1C', '\uD83D\uDE1D', '\uD83D\uDE1E', '\uD83D\uDE20', '\uD83D\uDE21',
    '\uD83D\uDE22', '\uD83D\uDE23', '\uD83D\uDE24', '\uD83D\uDE25', '\uD83D\uDE26',
    '\uD83D\uDE27', '\uD83D\uDE28', '\uD83D\uDE29', '\uD83D\uDE2A', '\uD83D\uDE2B',
    '\uD83D\uDE2D', '\uD83D\uDE30', '\uD83D\uDE31', '\uD83D\uDE32', '\uD83D\uDE33',
    '\uD83D\uDE34', '\uD83D\uDE35', '\uD83D\uDE36', '\uD83D\uDE37', '\uD83D\uDE38',
    '\uD83E\uDD23', '\uD83E\uDD24', '\uD83E\uDD25', '\uD83E\uDD26', '\uD83E\uDD27',
    '\uD83E\uDD28', '\uD83E\uDD29', '\uD83E\uDD2A', '\uD83E\uDD2B', '\uD83E\uDD2C',
    '\uD83E\uDD2D', '\uD83E\uDD2E', '\uD83E\uDD2F', '\uD83E\uDD70', '\uD83E\uDD71',
  ],
  gestures: [
    '\uD83D\uDC4D', '\uD83D\uDC4E', '\uD83D\uDC4C', '\uD83D\uDC4A', '\uD83D\uDC4B',
    '\uD83D\uDC4F', '\uD83D\uDC50', '\uD83E\uDD1A', '\uD83E\uDD1B', '\uD83E\uDD1C',
    '\uD83E\uDD1D', '\uD83E\uDD1E', '\uD83E\uDD1F', '\uD83E\uDD20', '\uD83D\uDE4F',
    '\uD83D\uDC40', '\uD83D\uDC42', '\uD83D\uDC43', '\uD83D\uDC44', '\uD83D\uDC45',
    '\uD83D\uDC46', '\uD83D\uDC47', '\uD83D\uDC48', '\uD83D\uDC49', '\uD83D\uDC4D\uD83C\uDFFB',
    '\u270C\uFE0F', '\u270A', '\u270B', '\u261D\uFE0F',
  ],
  hearts: [
    '\u2764\uFE0F', '\uD83D\uDC9B', '\uD83D\uDC9A', '\uD83D\uDC99', '\uD83D\uDC9C',
    '\uD83D\uDC94', '\uD83D\uDC95', '\uD83D\uDC96', '\uD83D\uDC97', '\uD83D\uDC98',
    '\uD83D\uDC9D', '\uD83D\uDC9E', '\uD83D\uDC9F', '\uD83E\uDD0E', '\uD83E\uDD0D',
    '\u2763\uFE0F', '\u2764\uFE0F\u200D\uD83D\uDD25', '\uD83D\uDD25',
  ],
  animals: [
    '\uD83D\uDC36', '\uD83D\uDC31', '\uD83D\uDC2D', '\uD83D\uDC30', '\uD83D\uDC39',
    '\uD83D\uDC22', '\uD83D\uDC18', '\uD83D\uDC2B', '\uD83D\uDC10', '\uD83D\uDC14',
    '\uD83D\uDC13', '\uD83D\uDC23', '\uD83D\uDC24', '\uD83D\uDC25', '\uD83D\uDC26',
    '\uD83D\uDC27', '\uD83E\uDD85', '\uD83E\uDD86', '\uD83E\uDD89', '\uD83E\uDD8A',
    '\uD83E\uDD8B', '\uD83E\uDD8C', '\uD83E\uDD8D', '\uD83D\uDC3C', '\uD83D\uDC3B',
  ],
  food: [
    '\uD83C\uDF47', '\uD83C\uDF48', '\uD83C\uDF49', '\uD83C\uDF4A', '\uD83C\uDF4B',
    '\uD83C\uDF4C', '\uD83C\uDF4D', '\uD83C\uDF4E', '\uD83C\uDF4F', '\uD83C\uDF50',
    '\uD83C\uDF51', '\uD83C\uDF52', '\uD83C\uDF53', '\uD83C\uDF45', '\uD83C\uDF46',
    '\uD83C\uDF47', '\uD83E\uDD50', '\uD83E\uDD51', '\uD83C\uDF54', '\uD83C\uDF5D',
    '\uD83C\uDF5F', '\uD83C\uDF63', '\uD83C\uDF64', '\uD83C\uDF65', '\uD83C\uDF66',
    '\uD83C\uDF67', '\uD83C\uDF68', '\uD83C\uDF69', '\u2615', '\uD83C\uDF7A',
  ],
  activities: [
    '\u26BD', '\uD83C\uDFC0', '\uD83C\uDFC8', '\u26BE', '\uD83C\uDFD0',
    '\uD83C\uDF93', '\uD83C\uDFC6', '\uD83C\uDFC7', '\uD83D\uDCBF', '\uD83D\uDCC0',
    '\uD83C\uDFA8', '\uD83C\uDFB5', '\uD83C\uDFB6', '\uD83C\uDFB8', '\uD83C\uDFB9',
    '\uD83C\uDFBA', '\uD83C\uDFBB', '\uD83C\uDFBC', '\uD83C\uDFBD', '\uD83C\uDFBE',
    '\u26BD', '\uD83E\uDD45', '\uD83E\uDD47', '\uD83E\uDD48', '\uD83E\uDD49',
  ],
  travel: [
    '\uD83D\uDE97', '\uD83D\uDE98', '\uD83D\uDE99', '\uD83D\uDE9B', '\uD83D\uDE9C',
    '\uD83D\uDE9D', '\uD83D\uDE9E', '\uD83D\uDE9F', '\uD83D\uDEA0', '\uD83D\uDEA2',
    '\uD83D\uDEA3', '\uD83D\uDEB2', '\uD83D\uDEB5', '\uD83D\uDEB6', '\uD83D\uDE81',
    '\u2708\uFE0F', '\uD83D\uDE80', '\uD83D\uDEF0', '\uD83C\uDFD9', '\uD83C\uDFD1',
    '\uD83C\uDFD2', '\uD83C\uDFA0', '\uD83C\uDFA1', '\uD83C\uDFA2',
  ],
  objects: [
    '\u231A', '\u231B', '\u23F0', '\u23F1', '\u23F2', '\u23F3',
    '\uD83D\uDCBB', '\uD83D\uDCBD', '\uD83D\uDCBE', '\uD83D\uDCBF', '\uD83D\uDCC0',
    '\uD83D\uDCFC', '\uD83D\uDD07', '\uD83D\uDD08', '\uD83D\uDD09', '\uD83D\uDD0A',
    '\uD83D\uDD0B', '\uD83D\uDD0C', '\uD83D\uDD0D', '\uD83D\uDD0E', '\uD83D\uDD0F',
    '\uD83D\uDD12', '\uD83D\uDD13', '\uD83D\uDD11', '\uD83D\uDD28', '\uD83D\uDD29',
  ],
  symbols: [
    '\u2714\uFE0F', '\u274C', '\u2753', '\u2754', '\u2755', '\u2757',
    '\u203C\uFE0F', '\u2049\uFE0F', '\u2753', '\u2705', '\u274E', '\u2744\uFE0F',
    '\u2728', '\uD83D\uDD25', '\uD83D\uDCA5', '\uD83D\uDCA4', '\u2728', '\u2B50',
    '\uD83D\uDC9C', '\uD83D\uDCAF', '\u26A0\uFE0F', '\u2139\uFE0F', '\uD83D\uDE00',
  ],
  flags: [
    '\uD83C\uDDE7\uD83C\uDDEA', '\uD83C\uDDF3\uD83C\uDDF1', '\uD83C\uDDF9\uD83C\uDDEF',
    '\uD83C\uDDFA\uD83C\uDDE6', '\uD83C\uDDE9\uD83C\uDDEA', '\uD83C\uDDE8\uD83C\uDDE6',
    '\uD83C\uDDF7\uD83C\uDDFA', '\uD83C\uDDF5\uD83C\uDDED', '\uD83C\uDDEA\uD83C\uDDFA',
    '\uD83C\uDDE6\uD83C\uDDFA', '\uD83C\uDDEE\uD83C\uDDF9', '\uD83C\uDDF4\uD83C\uDDED',
    '\uD83C\uDDF2\uD83C\uDDE6', '\uD83C\uDDFF\uD83C\uDDE6', '\uD83C\uDDF8\uD83C\uDDE6',
    '\uD83C\uDDF1\uD83C\uDDF0', '\uD83C\uDDEE\uD83C\uDDF3', '\uD83C\uDDF0\uD83C\uDDF7',
  ],
};

const MAX_RECENT = 32;
const STORAGE_KEY = 'aimessagebot-recent-emojis';

const loadRecent = (): string[] => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
};

const saveRecent = (emojis: string[]) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(emojis));
  } catch {
    // ignore storage errors
  }
};

interface EmojiPickerProps {
  onSelect: (emoji: string) => void;
}

const EmojiPicker = ({ onSelect }: EmojiPickerProps) => {
  const [activeCategory, setActiveCategory] = useState<keyof typeof EMOJI_CATEGORIES>('smileys');
  const [recent, setRecent] = useState<string[]>(() => loadRecent());

  const handleSelect = (emoji: string) => {
    onSelect(emoji);
    const next = [emoji, ...recent.filter((e) => e !== emoji)].slice(0, MAX_RECENT);
    setRecent(next);
    saveRecent(next);
  };

  const emojis = activeCategory === 'recent' ? recent : EMOJI_SETS[activeCategory];

  return (
    <div className="emoji-picker" role="dialog" aria-label="Emoji kiezen">
      <div className="emoji-picker-tabs" style={{ gridColumn: '1 / -1', display: 'flex', gap: '0.25rem', overflowX: 'auto', marginBottom: '0.4rem', paddingBottom: '0.3rem' }}>
        {(Object.keys(EMOJI_CATEGORIES) as (keyof typeof EMOJI_CATEGORIES)[]).map((key) => (
          <button
            key={key}
            type="button"
            className={`emoji-tab ${activeCategory === key ? 'active' : ''}`}
            onClick={() => setActiveCategory(key)}
            style={{
              flexShrink: 0,
              border: 'none',
              background: activeCategory === key ? 'var(--brand-soft)' : 'none',
              color: activeCategory === key ? 'var(--brand)' : 'var(--muted)',
              padding: '0.2rem 0.5rem',
              borderRadius: '6px',
              fontSize: '0.75rem',
              cursor: 'pointer',
              whiteSpace: 'nowrap',
            }}
          >
            {EMOJI_CATEGORIES[key]}
          </button>
        ))}
      </div>
      {emojis.length === 0 ? (
        <p className="muted" style={{ gridColumn: '1 / -1', textAlign: 'center', fontSize: '0.85rem', padding: '1rem 0' }}>
          Nog geen recente emoji's.
        </p>
      ) : (
        emojis.map((emoji, index) => (
          <button
            key={`${emoji}-${index}`}
            type="button"
            className="emoji-picker-button"
            onClick={() => handleSelect(emoji)}
            aria-label={`Emoji ${emoji} invoegen`}
          >
            {emoji}
          </button>
        ))
      )}
    </div>
  );
};

export default EmojiPicker;
